import atendimentoDomiciliarRepository from "./atendimentoDomiciliarRepository"
import atendimentoIndividualRepository from "./atendimentoIndividualRepository"
import atendimentoOdontologicoRepository from "./atendimentoOdontologicoRepository"
import atividadeColetivaRepository from "./atividadeColetivaRepository"
import avaliacaoRepository from "./avaliacao"
import cadastroDomiciliarRepository from "./cadastroDomiciliarRepository"
import cadastroIndividualRepository from "./cadastroIndividualRepository"
import exportacaoRepository from "./exportacaoRepository"
import fichaComplementarRepository from "./fichaComplementarRepository"
import fichaVacinacaoRepository from "./fichaVacinacaoRepository"
import marcadorConsumoAlimentar from "./marcadorConsumoAlimentarRepository"
import parametrizacaoRepository from "./parametrizacaoRepository"
import procedimentoRepository from "./procedimentoRepository"
import relatorioAtendimentoOdontologico from "./relatorioAtendimentoOdontologico"
import relatorioCadastroConsistenteRepository from "./relatorioCadastroConsistenteRepository"
import relatorioEstatisticoAtendimento from "./relatorioEstatisticoAtendimentoRepository"
import relatorioEstatisticoPacienteCadastradoRepository from "./relatorioEstatisticoPacienteCadastradoRepository"
import relatorioInconsistenciaRepository from "./relatorioInconsistenciaRepository"
import visitaDomiciliarRepository from "./visitaDomiciliarRepository"
import relatorioVisitaDomiciliarRepository from "./relatorioVisitaDomiciliarRepository"

export default baseUrl => {
    baseUrl = `${baseUrl}/atencao-basica`

    return {
        atendimentoDomiciliar: atendimentoDomiciliarRepository(baseUrl),
        atendimentoIndividual: atendimentoIndividualRepository(baseUrl),
        atendimentoOdontologico: atendimentoOdontologicoRepository(baseUrl),
        atividadeColetiva: atividadeColetivaRepository(baseUrl),
        avaliacao: avaliacaoRepository(baseUrl),
        cadastroDomiciliar: cadastroDomiciliarRepository(baseUrl),
        cadastroIndividual: cadastroIndividualRepository(baseUrl),
        exportacao: exportacaoRepository(baseUrl),
        fichaComplementar: fichaComplementarRepository(baseUrl),
        fichaVacinacao: fichaVacinacaoRepository(baseUrl),
        marcadorConsumoAlimentar: marcadorConsumoAlimentar(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        procedimento: procedimentoRepository(baseUrl),
        relatorioAtendimentoOdontologico: relatorioAtendimentoOdontologico(baseUrl),
        relatorioCadastroConsistente: relatorioCadastroConsistenteRepository(baseUrl),
        relatorioEstatisticoAtendimento: relatorioEstatisticoAtendimento(baseUrl),
        relatorioEstatisticoPacienteCadastrado: relatorioEstatisticoPacienteCadastradoRepository(baseUrl),
        relatorioInconsistencia: relatorioInconsistenciaRepository(baseUrl),
        visitaDomiciliar: visitaDomiciliarRepository(baseUrl),
        relatorioVisitaDomiciliar: relatorioVisitaDomiciliarRepository(baseUrl),
    }
}
